import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button 
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-8"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Zurück zur Startseite
        </Button>

        <div className="prose prose-slate max-w-none">
          <h1>Datenschutzerklärung</h1>

          <p>
            Mit diesen Datenschutzhinweisen informieren wir Sie über unseren Umgang mit Ihren personenbezogenen Daten 
            und über Ihre Rechte nach der Europäischen Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG). 
            Verantwortlich für die Datenverarbeitung ist die 2besales GmbH (nachfolgend als „wir" oder „uns" bezeichnet).
          </p>

          <h2>I. Allgemeine Angaben</h2>

          <h3>1. Kontakt</h3>
          <p>
            Wenn Sie Fragen oder Anregungen zu diesen Informationen haben oder sich wegen der Geltendmachung Ihrer Rechte 
            an uns wenden möchten, richten Sie Ihre Anfrage bitte an:
          </p>
          <p>
            Patrick Häfner<br />
            2besales GmbH<br />
            Westendstr. 25<br />
            80339 München<br />
            Deutschland<br />
            Tel.: +491726849896<br />
            E-Mail: info@2besales.de
          </p>

          <h3>2. Rechtsgrundlagen</h3>
          <p>
            Der datenschutzrechtliche Begriff „personenbezogene Daten" bezeichnet alle Informationen, die sich auf einen 
            bestimmten oder bestimmbaren Menschen beziehen. Wir verarbeiten personenbezogene Daten unter Beachtung der 
            einschlägigen Datenschutzvorschriften, insbesondere der DSGVO und des BDSG.
          </p>

          <h3>3. Dauer der Speicherung</h3>
          <p>
            Sofern sich aus den folgenden Hinweisen nichts anderes ergibt, speichern wir die Daten nur solange, wie es 
            zur Erreichung des Verarbeitungszwecks oder für die Erfüllung unserer vertraglichen oder gesetzlichen Pflichten 
            erforderlich ist.
          </p>

          <h3>4. Ihre Rechte</h3>
          <p>Als betroffene Person haben Sie das Recht, uns gegenüber Ihre Betroffenenrechte geltend zu machen:</p>
          <ul>
            <li>Recht auf Auskunft nach Art. 15 DSGVO und § 34 BDSG</li>
            <li>Recht auf Berichtigung nach Art. 16 DSGVO</li>
            <li>Recht auf Löschung nach Art. 17 DSGVO und § 35 BDSG</li>
            <li>Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO</li>
            <li>Recht auf Datenübertragbarkeit nach Art. 20 DSGVO</li>
            <li>Widerrufsrecht nach Art. 7 Abs. 3 DSGVO</li>
            <li>Beschwerderecht nach Art. 77 DSGVO</li>
          </ul>

          <h3>5. Widerspruchsrecht</h3>
          <p>
            Sie haben nach Maßgabe des Art. 21 Abs. 1 DSGVO das Recht, gegen Verarbeitungen, die auf der Rechtsgrundlage 
            des Art. 6 Abs. 1 Buchst. e oder f DSGVO beruhen, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, 
            Widerspruch einzulegen.
          </p>

          <h2>II. Datenverarbeitungen auf unserer Website</h2>

          <h3>1. Verarbeitung von Server-Log-Files</h3>
          <p>
            Bei der rein informativen Nutzung unserer Website werden zunächst automatisiert allgemeine Informationen 
            gespeichert, die Ihr Browser an unseren Server übermittelt.
          </p>

          <h3>2. Cookies</h3>
          <p>
            Wir verwenden auf unserer Website Cookies und vergleichbare Technologien. Sie haben durch Ihren Browser die 
            volle Kontrolle über die Verwendung von Cookies.
          </p>

          <h3>3. Kontaktmöglichkeiten und Anfragen</h3>
          <p>
            Unsere Website enthält Kontaktformulare, über welche Sie uns Nachrichten schicken können. Der Transfer Ihrer 
            Daten erfolgt dabei verschlüsselt.
          </p>

          <h3>4. Google Analytics</h3>
          <p>
            Wir verwenden auf unserer Website den Dienst Google Analytics des Anbieters Google Ireland Limited. Die 
            Verarbeitung erfolgt nur mit Ihrer Einwilligung.
          </p>

          <h2>III. Social-Media-Seiten</h2>

          <h3>1. Facebook- und Instagram-Seite</h3>
          <p>
            Bei dem Besuch unserer Facebook- oder Instagram-Seite werden bestimmte Informationen über Sie verarbeitet. 
            Allein verantwortlich für diese Verarbeitung ist Facebook Ireland Ltd.
          </p>

          <h3>2. LinkedIn-Unternehmensseite</h3>
          <p>
            Für die Verarbeitung personenbezogener Daten bei dem Besuch unserer LinkedIn-Seite ist grundsätzlich die 
            LinkedIn Ireland Unlimited Company allein verantwortlich.
          </p>

          <h2>IV. Weitere Datenverarbeitungen</h2>

          <h3>1. Kunden- und Interessentendaten</h3>
          <p>
            Wenn Sie als Kunde oder Interessent mit unserem Unternehmen in Kontakt treten, verarbeiten wir Ihre Daten 
            zur Begründung oder Durchführung der Vertragsbeziehung im dafür erforderlichen Umfang.
          </p>

          <h3>2. Verwendung der E-Mail-Adresse zu Marketingzwecken</h3>
          <p>
            Wir können Ihre bei Registrierung oder Bestellung angegebene E-Mail-Adresse verwenden, um Sie über eigene 
            ähnliche von uns angebotene Produkte und Leistungen zu informieren.
          </p>

          <p className="mt-8 text-sm text-slate-600">Stand: April 2021</p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
